export default __webpack_public_path__ + "static/media/DashVendas.ca7c1812.svg";